// extracted by mini-css-extract-plugin
export default {"input":"CommonTextArea_input__Pt7aQ","label":"CommonTextArea_label__+DRe6"};